export default __webpack_public_path__ + "static/media/scedul.7cebdc7f.png";